import { ReactNode }              from "react"
import Box                         from "@mui/material/Box"
import Stack                       from "@mui/material/Stack"
import MuiCard                     from "@mui/material/Card"
import { styled, ThemeProvider, Typography } from "@mui/material"
import { useGlobalConfig }         from "context/GlobalContext"
import { useThemeMode }            from "context/ThemeContext"
import { getTheme }                from "layouts/Theme/theme"
import logo                        from "../../assets/img/bidgely.png"

// Shared login-style card shell for the auth pages (login / forgot / reset).
const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}))

const AuthContainer = styled(Stack)(({ theme }) => ({
  height: '100dvh',
  minHeight: '100%',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}))

interface AuthCardProps {
  title    : string
  children : ReactNode
}

export const AuthCard = ({ title, children } : AuthCardProps) => {

  const { rc } = useGlobalConfig()
  const { mode } = useThemeMode()
  const theme = getTheme(rc, mode)

  return (
    <ThemeProvider theme={theme}>
      <AuthContainer direction="column" justifyContent="space-between">
        <Card variant="outlined">
          <img src={logo} alt="Bidgely" style={{ maxWidth: '120px', margin: '0 auto' }} />
          <Typography variant="bglTitle3">{title}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}>
            {children}
          </Box>
        </Card>
      </AuthContainer>
    </ThemeProvider>
  )
}
